import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { createOpenerStore } from './store.mjs';
import { ReactOpener } from './Renderer.mjs';

function useOpener() {
  var ref = useRef();
  if (!ref.current) {
    ref.current = createOpenerStore();
  }
  return [{
    open: ref.current.getState().open,
    close: ref.current.getState().close,
    closeAll: ref.current.getState().closeAll
  }, jsx(ReactOpener, {
    store: ref.current
  })];
}

export { useOpener };
